const ErrorDiv = ({ error }) => {
  return error ? (
    <div className="alert alert-danger px-2 py-1 mt-2" role="alert">
      <div style={{ fontSize: 12 }}>{error}</div>
    </div>
  ) : null;
};

export default ErrorDiv;
